import React, { useState } from "react";
import closeImg from "../../asserts/img/closeX.svg";
import { observer, inject } from "mobx-react";
import { useTranslation } from "react-i18next";
import searchImg from "../../asserts/img/search.svg";
import Input from "./Input";

const SearchInput = ({ handleSearchChange }) => {
  const { t, i18n } = useTranslation("common");
  const [inputValue, setInputValue] = useState("");
  const isRtl = i18n.dir() === "rtl";

  const handleClear = () => {
    handleSearchChange("");
    setInputValue("");
  };

  const handleChange = (e) => {
    handleSearchChange(e.target.value);
    setInputValue(e.target.value);
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        marginInlineStart: 5,
        height: 42,
        position: "relative",
      }}>
      <Input
        placeholder={t("search")}
        onChange={handleChange}
        startImg={searchImg}
        value={inputValue}
        style={{
          margin: 0,
          textAlign: "right",
          height: 42,
          overflow: "hidden",
          minWisth: 230,
          alignItems: "center",
        }}
      />
      {!!inputValue && (
        <img
          src={closeImg}
          alt="clear-input"
          onClick={handleClear}
          style={{
            width: 14,
            height: 14,
            position: "absolute",
            left: isRtl && 10,
            right: !isRtl && 10,
            top: 0,
            margin: "auto 0",
            bottom: 0,
          }}
        />
      )}
    </div>
  );
};

export default inject()(observer(SearchInput));
